import { makeApiActionCreatorV3 } from '@actions/utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import * as api from '../api/totalEstimate';

const namespace = 'PROCESS_MANAGER';

export const FETCH_TOTAL_ESTIMATES = createRequestTypes(
  `${namespace}/FETCH_TOTAL_ESTIMATES`,
);

export const fetchTotalEstimates = makeApiActionCreatorV3(
  api.fetchTotalEstimates,
  FETCH_TOTAL_ESTIMATES[START],
  FETCH_TOTAL_ESTIMATES[SUCCESS],
  FETCH_TOTAL_ESTIMATES[ERROR],
);

export const FETCH_TOTAL_RUN_YEAR = createRequestTypes(
  `${namespace}/FETCH_TOTAL_RUN_YEAR`,
);

export const fetchTotalRunByYear = makeApiActionCreatorV3(
  api.fetchTotalRunByYear,
  FETCH_TOTAL_RUN_YEAR[START],
  FETCH_TOTAL_RUN_YEAR[SUCCESS],
  FETCH_TOTAL_RUN_YEAR[ERROR],
);

export const FETCH_ROLL_CORRS_YEAR = createRequestTypes(
  `${namespace}/FETCH_ROLL_CORRS_YEAR`,
);

export const fetchRollCorrsByYear = makeApiActionCreatorV3(
  api.fetchRollCorrsByYear,
  FETCH_ROLL_CORRS_YEAR[START],
  FETCH_ROLL_CORRS_YEAR[SUCCESS],
  FETCH_ROLL_CORRS_YEAR[ERROR],
);

export const INITIALIZE_TOTALS = createRequestTypes(
  `${namespace}/INITIALIZE_TOTALS`,
);

export const initializeTotals = makeApiActionCreatorV3(
  api.initializeTotals,
  INITIALIZE_TOTALS[START],
  INITIALIZE_TOTALS[SUCCESS],
  INITIALIZE_TOTALS[ERROR],
);

export const FETCH_ESTIMATE = createRequestTypes(`${namespace}/FETCH_ESTIMATE`);

export const fetchEstimate = makeApiActionCreatorV3(
  api.fetchEstimate,
  FETCH_ESTIMATE[START],
  FETCH_ESTIMATE[SUCCESS],
  FETCH_ESTIMATE[ERROR],
);

export const FETCH_ESTIMATE_TAXING_UNITS = createRequestTypes(
  `${namespace}/FETCH_ESTIMATE_TAXING_UNITS`,
);

export const fetchEstimateTaxingUnits = makeApiActionCreatorV3(
  api.fetchEstimateTaxingUnits,
  FETCH_ESTIMATE_TAXING_UNITS[START],
  FETCH_ESTIMATE_TAXING_UNITS[SUCCESS],
  FETCH_ESTIMATE_TAXING_UNITS[ERROR],
);

export const FETCH_ESTIMATE_LAYOUT = createRequestTypes(
  `${namespace}/FETCH_ESTIMATE_LAYOUT`,
);

export const fetchEstimateLayout = makeApiActionCreatorV3(
  api.fetchEstimateLayout,
  FETCH_ESTIMATE_LAYOUT[START],
  FETCH_ESTIMATE_LAYOUT[SUCCESS],
  FETCH_ESTIMATE_LAYOUT[ERROR],
);

export const CALC_ESTIMATE_DATA = createRequestTypes(
  `${namespace}/CALC_ESTIMATE_DATA`,
);

export const calcEstimateData = makeApiActionCreatorV3(
  api.calcEstimateData,
  CALC_ESTIMATE_DATA[START],
  CALC_ESTIMATE_DATA[SUCCESS],
  CALC_ESTIMATE_DATA[ERROR],
);

export const SAVE_CALC_ESTIMATE_DATA = createRequestTypes(
  `${namespace}/SAVE_CALC_ESTIMATE_DATA`,
);

export const saveCalcEstimate = makeApiActionCreatorV3(
  api.saveCalcEstimate,
  SAVE_CALC_ESTIMATE_DATA[START],
  SAVE_CALC_ESTIMATE_DATA[SUCCESS],
  SAVE_CALC_ESTIMATE_DATA[ERROR],
);

export const SAVE_TAXING_UNITS = createRequestTypes(
  `${namespace}/SAVE_TAXING_UNITS`,
);

export const saveTaxingUnits = makeApiActionCreatorV3(
  api.saveTaxingUnits,
  SAVE_TAXING_UNITS[START],
  SAVE_TAXING_UNITS[SUCCESS],
  SAVE_TAXING_UNITS[ERROR],
);
